import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

const MentionsLegales = () => {
  useEffect(() => {
    document.title = "Mentions légales · Gwladys Malalaka · PSIQ";
    window.scrollTo(0, 0);
  }, []);

  const today = new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" });

  return (
    <main className="bg-cream text-ink min-h-screen" data-testid="page-mentions-legales">
      <header className="bg-deep-teal text-ivory py-12">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <a href="/" className="inline-flex items-center gap-2 text-sm text-ivory/80 hover:text-coral transition-colors mb-6" data-testid="back-home">
            <ArrowLeft size={16} /> Retour à l'accueil
          </a>
          <h1 className="font-display text-3xl md:text-5xl leading-tight">Mentions légales <span className="italic text-coral">&amp;</span> Politique de confidentialité</h1>
          <p className="mt-3 text-ivory/70 text-sm">Dernière mise à jour : {today}</p>
        </div>
      </header>

      <article className="max-w-4xl mx-auto px-6 lg:px-10 py-16 space-y-10 text-ink/85 text-base leading-relaxed">

        <section data-testid="section-editeur">
          <h2 className="font-display text-2xl text-deep-teal">1. Éditrice du site</h2>
          <div className="mt-4 space-y-1">
            <p><strong>Nom :</strong> Gwladys Malalaka</p>
            <p><strong>Statut :</strong> Micro-entreprise — <em>en cours d'immatriculation</em></p>
            <p><strong>Activité :</strong> Thérapeute holistique — Psychanalyse PSIQ (Structurale Informationnelle et Quantique), méthode AFAKA (approche globale post burn-out), formation &amp; transmission (méthode Boclet, bio-thérapie), art-thérapie, coaching, développement personnel, accompagnement à la réorganisation du quotidien.</p>
            <p><strong>Adresse professionnelle :</strong> Bâtiment 25 — Limoges, Haute-Vienne (87)</p>
            <p><strong>Téléphone :</strong> <a href="tel:0782850043" className="text-deep-teal underline">07 82 85 00 43</a></p>
            <p><strong>Email :</strong> <a href="mailto:psiq@gwladysmalalaka.com" className="text-deep-teal underline">psiq@gwladysmalalaka.com</a></p>
            <p><strong>Directrice de publication :</strong> Gwladys Malalaka</p>
          </div>
        </section>

        <section data-testid="section-hebergeur">
          <h2 className="font-display text-2xl text-deep-teal">2. Hébergement</h2>
          <div className="mt-4 space-y-1">
            <p>Le site <strong>gwladysmalalaka.com</strong> est hébergé par :</p>
            <p><strong>Emergent Labs</strong> — plateforme d'hébergement cloud</p>
            <p>Service d'hébergement sécurisé (HTTPS/SSL) avec distribution via Cloudflare Inc.</p>
            <p><strong>Nom de domaine :</strong> enregistré auprès d'OVH SAS — 2 rue Kellermann, 59100 Roubaix, France — RCS Lille Métropole 424 761 419</p>
          </div>
        </section>

        <section data-testid="section-propriete">
          <h2 className="font-display text-2xl text-deep-teal">3. Propriété intellectuelle</h2>
          <div className="mt-4 space-y-3">
            <p>L'ensemble des contenus du site (textes, images, photographies, vidéos, œuvres artistiques, logos, graphismes, structure du site) est la propriété exclusive de Gwladys Malalaka, sauf mention contraire. Ces contenus sont protégés par le Code de la Propriété Intellectuelle (articles L111-1 et suivants).</p>
            <p className="text-coral font-medium">Toute reproduction, représentation, modification, publication, adaptation ou exploitation — totale ou partielle — des éléments du site, par quelque procédé que ce soit, est strictement interdite sans autorisation écrite préalable de l'auteure.</p>
            <p>Les œuvres présentées dans la galerie (notamment « Autobiographie — triptyque » et « Un enfant dans la lumière sortant de l'ombre ») sont protégées par filigrane numérique. Toute utilisation sans consentement expose l'auteur·e des faits à des poursuites judiciaires.</p>
          </div>
        </section>

        <section data-testid="section-donnees">
          <h2 className="font-display text-2xl text-deep-teal">4. Données personnelles &amp; RGPD</h2>
          <div className="mt-4 space-y-3">
            <p>Conformément au Règlement Général sur la Protection des Données (RGPD — Règlement UE 2016/679) et à la loi « Informatique et Libertés » du 6 janvier 1978 modifiée :</p>

            <h3 className="font-display text-lg text-deep-teal mt-6">Données collectées</h3>
            <p>Les données que vous nous communiquez via les formulaires (nom, email, téléphone, message) sont collectées uniquement pour :</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>vous répondre et organiser un rendez-vous</li>
              <li>assurer le suivi de votre accompagnement (si vous en devenez bénéficiaire)</li>
              <li>vous transmettre ponctuellement des ressources si vous avez complété le quiz PSIQ</li>
            </ul>

            <h3 className="font-display text-lg text-deep-teal mt-6">Finalité &amp; conservation</h3>
            <p>Vos données ne sont <strong>jamais vendues, louées, ni transmises à des tiers</strong> à des fins commerciales. Elles sont conservées :</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>3 ans</strong> à compter du dernier contact pour les demandes de renseignement</li>
              <li><strong>10 ans</strong> pour les factures et documents comptables (obligation légale)</li>
              <li>effacées sur simple demande pour les inscriptions au quiz / newsletter</li>
            </ul>

            <h3 className="font-display text-lg text-deep-teal mt-6">Vos droits</h3>
            <p>Vous disposez d'un droit d'accès, de rectification, de suppression, de portabilité, de limitation et d'opposition au traitement de vos données. Pour exercer ces droits :</p>
            <p className="pl-6">→ Email : <a href="mailto:psiq@gwladysmalalaka.com" className="text-deep-teal underline">psiq@gwladysmalalaka.com</a></p>
            <p>En cas de difficulté, vous pouvez saisir la CNIL : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-deep-teal underline">www.cnil.fr</a></p>

            <h3 className="font-display text-lg text-deep-teal mt-6">Confidentialité des séances</h3>
            <p>Les séances de thérapie PSIQ sont soumises à une <strong>confidentialité absolue</strong>. Aucune information échangée en séance n'est divulguée, partagée ou stockée numériquement sans votre consentement écrit.</p>
          </div>
        </section>

        <section data-testid="section-cookies">
          <h2 className="font-display text-2xl text-deep-teal">5. Cookies &amp; mesure d'audience</h2>
          <div className="mt-4 space-y-3">
            <p>Le site utilise <strong>Google Analytics 4</strong> pour mesurer de manière anonymisée la fréquentation du site et améliorer l'expérience des visiteurs. Les données collectées (pages visitées, durée, zone géographique approximative) sont agrégées et ne permettent pas de vous identifier personnellement.</p>
            <p>Vous pouvez refuser le dépôt de cookies Google Analytics en activant l'option « Do Not Track » de votre navigateur, ou en installant l'extension officielle Google : <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-deep-teal underline">tools.google.com/dlpage/gaoptout</a>.</p>
          </div>
        </section>

        <section data-testid="section-avertissement">
          <h2 className="font-display text-2xl text-deep-teal">6. Avertissement médical</h2>
          <div className="mt-4 space-y-3 bg-ivory p-6 rounded-2xl border border-ink-soft">
            <p>La pratique de la <strong>Psychanalyse holistique PSIQ</strong> proposée sur ce site est une approche de <strong>bien-être et de développement personnel</strong>. Elle est <strong>distincte</strong> de la médecine conventionnelle, de la psychiatrie et de la psychologie clinique.</p>
            <p className="text-coral font-medium">Elle ne se substitue en aucun cas à un suivi médical, psychiatrique ou psychologique. En cas de symptômes sévères (dépression profonde, idées suicidaires, troubles graves), consultez impérativement un médecin ou contactez :</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>15</strong> — SAMU / urgences médicales</li>
              <li><strong>3114</strong> — Numéro national de prévention du suicide (gratuit, 24h/24)</li>
              <li><strong>3919</strong> — Violences Femmes Info</li>
            </ul>
          </div>
        </section>

        <section data-testid="section-responsabilite">
          <h2 className="font-display text-2xl text-deep-teal">7. Responsabilité</h2>
          <div className="mt-4 space-y-3">
            <p>Gwladys Malalaka s'efforce de fournir des informations aussi précises que possible. Cependant, elle ne saurait être tenue responsable des erreurs, omissions ou indisponibilités temporaires du site.</p>
            <p>Les liens externes présents sur le site le sont à titre informatif. Gwladys Malalaka ne peut être tenue responsable du contenu des sites tiers vers lesquels ces liens pointent.</p>
          </div>
        </section>

        <section data-testid="section-droit">
          <h2 className="font-display text-2xl text-deep-teal">8. Droit applicable &amp; juridiction compétente</h2>
          <div className="mt-4 space-y-3">
            <p>Les présentes mentions légales sont régies par le <strong>droit français</strong>.</p>
            <p>En cas de litige, une <strong>tentative de résolution amiable</strong> sera privilégiée avant toute action contentieuse. À défaut d'accord, et conformément aux <strong>articles 42 et suivants du Code de procédure civile</strong>, le <strong>Tribunal Judiciaire de Limoges</strong> sera seul compétent pour connaître du litige.</p>
            <p className="text-sm text-ink/70 italic">Conformément à l'article L.612-1 du Code de la consommation, vous pouvez également recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable du litige.</p>
          </div>
        </section>

        <section data-testid="section-contact">
          <h2 className="font-display text-2xl text-deep-teal">9. Contact</h2>
          <div className="mt-4 space-y-3">
            <p>Pour toute question relative aux présentes mentions légales ou au traitement de vos données :</p>
            <p className="text-lg">
              <a href="mailto:psiq@gwladysmalalaka.com" className="text-deep-teal underline font-medium">psiq@gwladysmalalaka.com</a>
            </p>
          </div>
        </section>

        <div className="pt-10 border-t border-ink-soft text-sm text-ink/60">
          <a href="/" className="inline-flex items-center gap-2 text-deep-teal hover:text-coral transition-colors" data-testid="back-home-bottom">
            <ArrowLeft size={14} /> Retour à l'accueil
          </a>
        </div>
      </article>
    </main>
  );
};

export default MentionsLegales;
